import React from "react";
import PrinterScene from "@/components/hero/PrinterScene";

/**
 * HeroBackground — the animated printer scene backdrop for the hero.
 * The actual SVG lives in PrinterScene; this file just handles the wrapper.
 */
export default function HeroBackground() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      <PrinterScene />
      <div className="absolute inset-0 hero-hotspot" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0C] via-[#0A0A0C]/85 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0C] via-transparent to-[#0A0A0C]/40" />
      <div className="hero-scanlines" />
    </div>
  );
}
